module.exports = __webpack_public_path__ + "img/calendar-inactive.7ef2db4e.png";